import React from 'react';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { DRIVER_LICENCE_ICONS } from '@yme/common/constants';
export const TEST_RIDE_WRAPPER_ID = 'TestRideGridWrapper';
export const PARAMS_KEYS = {
    page: 'page',
    perPage: 'perPage',
    driverLicense: 'driverLicense',
    dealerId: 'dealerId',
    dealerIds: 'dealerIds',
    isIframe: 'isIframe',
};
export const HEADER_MARGIN = 160;
export const ALL_DRIVER_LICENCE_KEY = 'ALL';
export const DRIVER_LICENCE_CONFIG = [
    {
        value: ALL_DRIVER_LICENCE_KEY,
        label: 'All driver licence',
    },
    {
        value: 'A',
        label: 'A',
        icon: React.createElement(SVGIcon, { type: DRIVER_LICENCE_ICONS.A }),
    },
    {
        value: 'A1',
        label: 'A1',
        icon: React.createElement(SVGIcon, { type: DRIVER_LICENCE_ICONS.A1 }),
    },
    {
        value: 'A2',
        label: 'A2',
        icon: React.createElement(SVGIcon, { type: DRIVER_LICENCE_ICONS.A2 }),
    },
    {
        value: 'AM',
        label: 'AM',
        icon: React.createElement(SVGIcon, { type: DRIVER_LICENCE_ICONS.AM }),
    },
    {
        value: 'B',
        label: 'B',
        icon: React.createElement(SVGIcon, { type: DRIVER_LICENCE_ICONS.B }),
    },
];
export const TEST_RIDE_ERROR_ALERT_TEST_ID = 'test-ride_error-alert';
export const LICENSE_DROPDOWN_LABEL = 'licenseDropdown';
export const DEALER_ID_SEPARATOR = ',';
